import { action, Action } from 'easy-peasy';
import { MogMenuType } from '@/types';

export interface IMogCollapseModel {
    /** 销毁对象 */
    destroy: Action<IMogCollapseModel>;
    /** 当前面板类型 */
    currentType: MogMenuType | '';
    /** 设置当前面板类型 */
    setCurrentType: Action<IMogCollapseModel, MogMenuType | ''>;
}

export const mogCollapseModel: IMogCollapseModel = {
    destroy: action((state) => {
        state.currentType = '';
    }),
    currentType: '',
    setCurrentType: action((state, payload) => {
        state.currentType = payload;
    }),
};
